import { render, staticRenderFns } from "./BaseStatsCard.vue?vue&type=template&id=e1e1f6c0&"
import script from "./BaseStatsCard.vue?vue&type=script&lang=js&"
export * from "./BaseStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports